import {AppConfig} from './appConfig.types';
import {getConfig} from './config';

const getBaseConfig = () => (getConfig() as AppConfig).baseConfig;

const getMarketLanguages = () => getBaseConfig().marketLanguages || [];
const getGreetings = () => getBaseConfig().greetings || [];
const getIsQureMarket = () => getBaseConfig().isQureMarket;
const getIsUnregistrationEnabled = () => getBaseConfig().isUnregistrationEnabled;
const getIsWelcomeScreenEnabled = () => getBaseConfig().isWelcomeScreenEnabled;
const getIsAutoDeliveryEnabled = () => getBaseConfig().isAutoDeliveryEnabled;
const getIsTradeInEnabled = (deviceType: string) => {
    const tradeInDeviceTypes = getBaseConfig().tradeInDeviceTypes || [];

    return tradeInDeviceTypes.some((x) => x.deviceType === deviceType);
};

export default {
    getMarketLanguages,
    getGreetings,
    getIsQureMarket,
    getIsUnregistrationEnabled,
    getIsWelcomeScreenEnabled,
    getIsAutoDeliveryEnabled,
    getIsTradeInEnabled,
};
